type ArticleIconProps = {
  strokeWidthThick?: number;
  strokeWidthThin?: number;
  fill?: string;
};

const ArticleIcon: React.FC<
  ArticleIconProps & React.SVGAttributes<SVGElement>
> = ({ strokeWidthThick = 4, strokeWidthThin = 2.5, fill, ...svgProps }) => (
  <svg
    viewBox="20.113 18.774 154.399 111.54"
    width={154.399}
    height={111.54}
    overflow="visible"
    fill="none"
    {...svgProps}
  >
    <path
      d="M160.037 130.314c14.475 0 14.475-13.943 14.475-13.943V28.069h-28.95m14.475 102.245c-14.475 0-14.475-13.943-14.475-13.943V28.069m14.475 102.245H42.177c-23.159 0-22.056-22.308-22.056-22.308V18.774h125.441v9.295"
      strokeWidth={strokeWidthThick}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill={fill}
    />
    <path
      d="M49.063 74.544h28.95m19.3 0h19.3m-67.55-25.562h67.55m-67.55 37.181h67.55m-67.55 11.619h67.55"
      strokeWidth={strokeWidthThin}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </svg>
);

export default ArticleIcon;
